import { randInt } from '../utils/fractionMath';

export function generateTopic1Questions(count = 10) {
  const questions = [];
  for (let i = 0; i < count; i++) {
    const den = randInt(3, 12);
    let num1 = randInt(1, den - 1);
    let num2 = randInt(1, den - 1);
    // ~20% chance of equal fractions
    if (Math.random() < 0.2) num2 = num1;

    const correctAnswer = num1 < num2 ? '<' : num1 > num2 ? '>' : '=';

    questions.push({
      id: `t1_${i}`,
      topicId: 1,
      type: 'compare',
      prompt: 'Salīdzini daļas! Kurš zīme ir pareiza?',
      data: { num1, den1: den, num2, den2: den },
      correctAnswer,
    });
  }
  return questions;
}
